/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase2_Fix_Public_Tool_UnavailableInputs */

const en_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This free tool is unavailable right now. Try again later.`)
};

const zh_hans1_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个免费工具暂时不可用，请稍后再试。`)
};

const pt_br2_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta grátis está indisponível agora. Tente de novo mais tarde.`)
};

const es_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta herramienta gratis no está disponible en este momento. Inténtalo más tarde.`)
};

const fr_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet outil gratuit est indisponible pour le moment. Réessayez plus tard.`)
};

const de_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses kostenlose Tool ist gerade nicht verfügbar. Versuch es später erneut.`)
};

const ru_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот бесплатный инструмент сейчас недоступен. Повторите позже.`)
};

const it_phase2_fix_public_tool_unavailable = /** @type {(inputs: Phase2_Fix_Public_Tool_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo strumento gratuito non è disponibile al momento. Riprova più tardi.`)
};

/**
* | output |
* | --- |
* | "This free tool is unavailable right now. Try again later." |
*
* @param {Phase2_Fix_Public_Tool_UnavailableInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_public_tool_unavailable = /** @type {((inputs?: Phase2_Fix_Public_Tool_UnavailableInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Public_Tool_UnavailableInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_public_tool_unavailable(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_public_tool_unavailable(inputs)
	if (locale === "es") return es_phase2_fix_public_tool_unavailable(inputs)
	if (locale === "fr") return fr_phase2_fix_public_tool_unavailable(inputs)
	if (locale === "de") return de_phase2_fix_public_tool_unavailable(inputs)
	if (locale === "ru") return ru_phase2_fix_public_tool_unavailable(inputs)
	if (locale === "it") return it_phase2_fix_public_tool_unavailable(inputs)
	return en_phase2_fix_public_tool_unavailable(inputs)
});